<script setup lang="ts">
const props = defineProps({
  imageUrl: { type: String, required: true }
})

const emit = defineEmits(['handleDialog'])
</script>

<template>
  <v-card border="opacity-35 sm" class="ma-2" variant="text">
    <v-skeleton-loader :loading="!imageUrl" height="320" type="ossein" class="pa-2">
      <v-img
        v-if="imageUrl"
        :src="imageUrl"
        height="320"
        alt="Cross Section Image"
        @click="emit('handleDialog', imageUrl)"
      />
    </v-skeleton-loader>
  </v-card>
</template>

<style scoped>
.v-img {
  cursor: pointer;
}
</style>
